$('[data-scroll-to]').click(function(e){
	e.preventDefault();

	let targetID 	= $(this).data('scroll-to');
	let target 		= $(targetID);
	let navbarH 	= $('.bar-navigation');

	console.log(navbarH.outerHeight());

	if(target.length > 0){
		let offset = target.offset();

		$('body, html').animate({
			scrollTop: (offset.top - navbarH.outerHeight())
		},1000);

		$(this).blur();

	}else{
		return false;
	}
});